import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { AccessField } from "src/app/Canales/Shared/Types/Enums/access-field.enum";
import { NewUserAccessData } from "src/app/Canales/Shared/Types/new-user";

@Injectable()
export class CanalesAccessFormService {
  public refreshFormControls(controls: Record<string, AbstractControl>): void {
    Object.values(controls).forEach((control) => control.updateValueAndValidity({ onlySelf: true, emitEvent: false }));
  }

  public isRequired(field: AccessField[] | AccessField, requiredFields: Partial<Record<AccessField, boolean>>): ValidatorFn {
    return (control): ValidationErrors | null => {
      const fields = Array.isArray(field) ? field : [field];
      const isRequired = fields.some((f) => requiredFields[f]);
      return isRequired ? Validators.required(control) : null;
    };
  }

  public onSubmit(form: UntypedFormGroup, requiredFields: Partial<Record<AccessField, boolean>>): NewUserAccessData {
    const formValue = form.value;
    const value = Object.entries(formValue).reduce((acc, [key, currentValue]) => {
      if (requiredFields[key] !== null && requiredFields[key] !== undefined) {
        acc[key] = currentValue;
      }
      return acc;
    }, {});

    if (formValue.isUserCanales === null) formValue.isUserCanales = false;
    if (formValue.isUserAdmin === null) formValue.isUserAdmin = false;

    const submitValue = {
      ...value,
      email: formValue.email,
      roles: formValue.roles,
      profile: formValue.profile,
      isUserCanales: formValue.isUserCanales,
      isUserAdmin: formValue.isUserAdmin,
    };

    return submitValue as NewUserAccessData;
  }

  public showField(field: AccessField, requiredFields: Partial<Record<AccessField, boolean>>): boolean {
    return Object.keys(requiredFields).includes(String(field));
  }

  public getFormValue(form: UntypedFormGroup, value: string): AbstractControl {
    return form?.get(`${value}`)?.value;
  }
}
